import { Component, Input, OnInit } from '@angular/core';
import { SidebarState } from '@app/core/sidebar/store/sidebar.state';
import { AppState } from '@app/core/store/app.state';
import { InitialInfo, SidebarMenuItem } from '@app/_interfaces';
import { McToastService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MarketConfiguration, MarketData } from '@app/_interfaces/configuration/marketdata.interface';

@Component({
    selector: 'app-trial-expired',
    templateUrl: './trial-expired.component.html',
    styleUrls: ['./trial-expired.component.scss'],
})
export class TrialExpiredComponent implements OnInit {
    sideBarWidth: number;
    expiredAt: string = '';
    alertHeight: number;

    title = new Map<string, string>([
        ['expired', this.translate.instant('app.global.site_info_banner.expired.title')],
        // ['expired', this.translate.instant('app.global.site_info_banner.expired.promo.title')],
        ['disabled', this.translate.instant('app.global.site_info_banner.disabled.title')],
        ['deleted', this.translate.instant('app.global.site_info_banner.deleted.title')],
    ]);
    subtitle = new Map<string, string>([
        ['expired', this.translate.instant('app.global.site_info_banner.expired.promo.bajamos_los_precios')],
        ['disabled', this.translate.instant('app.global.site_info_banner.disabled.subtitle')],
        ['deleted', this.translate.instant('app.global.site_info_banner.deleted.subtitle')],
    ]);
    content = new Map<string, string>([
        // ['expired', this.translate.instant('app.global.site_info_banner.expired.content')],
        ['expired', this.translate.instant('app.global.site_info_banner.expired.promo.subtitle')],
        ['disabled', this.translate.instant('app.global.site_info_banner.disabled.content')],
        ['deleted', this.translate.instant('app.global.site_info_banner.deleted.content')],
    ]);
    ctaText = new Map<string, string>([
        ['expired', this.translate.instant('app.global.site_info_banner.expired.cta_text')],
        ['disabled', this.translate.instant('app.global.site_info_banner.disabled.cta_text')],
        ['deleted', this.translate.instant('app.global.site_info_banner.deleted.cta_text')],
    ]);

    @Input() remainingDemoDays: number;
    @Input() bannerType: 'expired' | 'disabled' | 'deleted';

    @Select(AppState.getConfig)
    config$: Observable<{}>;
    @Select(SidebarState.menu)
    menuItems$: Observable<SidebarMenuItem[]>;
    @Select(SidebarState.collapsed)
    isCollapsed$: Observable<boolean>;

    @Select(SidebarState.initialInfo)
    initialInfo$: Observable<InitialInfo>;

    marca_blanca: boolean;

    @Select(AppState.getConfig)
    marketConfiguration$: Observable<MarketConfiguration>;

    ver_planes_link: string = '';

    constructor(public mcToast: McToastService, private translate: TranslateService, private store: Store) {
        this.getPlanesLink();
    }

    ngOnInit(): void {
        this.config$.subscribe(() => {
            this.setAlertHeight();
            //this.setExpiredAt();
            this.checkMarcaBlanca();
        });
        this.menuItems$.subscribe((items) => {
            if (items.length) {
                let sidebar = document.querySelector('.mc-sidebar__profile');
                this.sideBarWidth = sidebar?.clientWidth;
            }
        });
        this.isCollapsed$.subscribe(() => {
            setTimeout(() => {
                let sidebar = document.querySelector('.mc-sidebar__profile');
                if (sidebar) this.sideBarWidth = sidebar?.clientWidth;
            }, 50);
        });
    }

    setExpiredAt() {
        const iso = this.store.selectSnapshot(AppState.getMarketLanguage).iso.replace('_', '-');
        const remainingDaysInMiliseconds = this.remainingDemoDays * 24 * 60 * 60 * 1000;
        const todayInMiliseconds = new Date().getTime();
        const expiredDate = new Date(todayInMiliseconds + remainingDaysInMiliseconds).toLocaleString(iso, {
            day: 'numeric',
            month: 'long',
        });
        this.subtitle.set(
            'expired',
            `${this.translate.instant('app.global.site_info_banner.expired.subtitle')} ${expiredDate}`
        );
    }

    setAlertHeight() {
        setTimeout(() => {
            this.alertHeight = document.querySelector('.trial-container').clientHeight;
        }, 100);
    }

    getPlanesLink() {
        this.marketConfiguration$.subscribe((data: MarketConfiguration) => {
            this.ver_planes_link = `https://donweb.com/es-ar/diy-hazte-premium?idHosting=${data.idhosting}&idMarket=${data.idMarket}&newDIY=true`;
        });
    }

    private checkMarcaBlanca(): void {
        this.initialInfo$.subscribe((res) => {
            this.marca_blanca = res?.data?.mainMarket?.marcablanca;
            this.content = new Map<string, string>([
                [
                    'expired',
                    this.marca_blanca
                        ? this.translate.instant('app.global.site_info_banner.expired.content_marca_blanca')
                        : this.translate.instant('app.global.site_info_banner.expired.promo.subtitle'),
                ],
                [
                    'disabled',
                    this.marca_blanca
                        ? this.translate.instant('app.global.site_info_banner.disabled.content_marca_blanca')
                        : this.translate.instant('app.global.site_info_banner.disabled.content'),
                ],
                [
                    'deleted',
                    this.marca_blanca
                        ? this.translate.instant('app.global.site_info_banner.deleted.content_marca_blanca')
                        : this.translate.instant('app.global.site_info_banner.deleted.content'),
                ],
            ]);

            this.title = new Map<string, string>([
                [
                    'expired',
                    this.marca_blanca
                        ? this.translate.instant('app.global.site_info_banner.expired.title')
                        : this.translate.instant('app.global.site_info_banner.expired.promo.title'),
                ],
                ['disabled', this.translate.instant('app.global.site_info_banner.disabled.title')],
                ['deleted', this.translate.instant('app.global.site_info_banner.deleted.title')],
            ]);

            if (this.marca_blanca) {
                this.setExpiredAt();
            }
        });
    }
}
